<template>
  <div>
    <div class="main">
      <div class="header" v-if="flag">
        <ul>
          <li>
            <a
              href="javascript:;"
              @click="category(1)"
              :class="{ choose: isChoose == 1 }"
            >
              未提出 (
              <strong>{{ tabData.orderTemporary }}</strong>
              )
            </a>
            <span>|</span>
          </li>
          <li>
            <a
              href="javascript:;"
              @click="category(0)"
              :class="{ choose: isChoose == 0 }"
            >
              注文書 (
              <strong>{{ tabData.all }}</strong>
              )
            </a>
            <span>|</span>
          </li>
          <li>
            <a
              href="javascript:;"
              @click="category(2)"
              :class="{ choose: isChoose == 2 }"
            >
              見積中 (
              <strong>{{ tabData.orderConfirm }}</strong>
              )
            </a>
            <span>|</span>
          </li>
          <li>
            <a
              href="javascript:;"
              @click="category(3)"
              :class="{ choose: isChoose == 3 }"
            >
              支払い待ち (
              <strong>{{ tabData.orderPay }}</strong>
              )
            </a>
            <span>|</span>
          </li>
          <li>
            <a
              href="javascript:;"
              @click="category(4)"
              :class="{ choose: isChoose == 4 }"
            >
              買い付け中 (
              <strong>{{ tabData.orderPurchase }}</strong>
              )
            </a>
            <span>|</span>
          </li>
          <li>
            <a
              href="javascript:;"
              @click="category(5)"
              :class="{ choose: isChoose == 5 }"
            >
              買い付け完了 (
              <strong>{{ tabData.orderPurchased }}</strong>
              )
            </a>
            <span>|</span>
          </li>
        </ul>
        <a href="javascript:;" class="fr history" @click="historyOrder"
          >過去の注文書</a
        >
      </div>
      <div class="header" v-else>
        <a href="javascript:;" class="history fl">過去の注文書</a>
        <div class="search fl">
          <input type="text" v-model="list.ordno" placeholder="注文書番号" />
          <a href="javascript:;" @click="getOrderList">確定</a>
        </div>
        <span class="fanghui fr" @click="backtrack">戻る</span>
      </div>
      <div id="search" v-if="flag">
        <div class="date fl">
          日付
          <el-date-picker
            v-model="list.dateStart"
            type="date"
            placeholder="日付を選択"
            size="small"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
          -
          <el-date-picker
            v-model="list.dateEnd"
            type="date"
            placeholder="日付を選択"
            value-format="yyyy-MM-dd"
            size="small"
          ></el-date-picker>
          <a href="javascript:;" @click="getOrderList">確定</a>
        </div>
        <div class="search fr">
          <input type="text" v-model="list.ordno" placeholder="注文書番号" />
          <a href="javascript:;" @click="getOrderList">確定</a>
        </div>
      </div>
      <div class="content">
        <!-- 头部 -->
        <ol v-if="flag">
          <li class="w40">NO</li>
          <li class="w278">注文書番号</li>
          <li class="w103">提出日付</li>
          <li class="w103">入金日</li>
          <li class="w103">買付完了</li>
          <li class="w103">预计到货时间</li>
          <!-- <li class="w110">エクセル導出</li> -->
          <li class="w145">注文書状態</li>
          <li class="w65">操作</li>
        </ol>
        <ol v-else>
          <li class="w40">NO</li>
          <li class="w278">注文書番号</li>
          <li class="w103">提出日付</li>
          <li class="w110">エクセル導出</li>
          <li class="w145">注文書状態</li>
        </ol>
        <!-- 订单内容 -->
        <div v-if="flag">
          <ul v-for="(item, index) in orderList.list" :key="index">
            <li class="w40">{{ index + 1 }}</li>
            <li class="w278">
              <router-link
                target="_blank"
                :to="{ name: 'zhuwen', query: { ordno: item.ordno } }"
                >{{ item.ordno }}</router-link
              >
            </li>
            <li class="w103">{{ item.datetime }}</li>
            <li class="w103" v-if="item.datetime4 == null">--</li>
            <li v-else>{{ item.datetime4 }}</li>
            <li class="w103" v-if="item.datetime6 == null">--</li>
            <li v-else>{{ item.datetime6 }}</li>
            <li>--</li>
            <li class="w145">{{ item.statusName }}</li>
            <li class="w65">
              <router-link
                target="_blank"
                :to="{ name: 'zhuwen', query: { ordno: item.ordno } }"
                v-if="item.kno == 3"
                >支払い</router-link
              >
              <i
                class="el-icon-delete"
                @click="delOrder(item)"
                v-if="item.kno == 3 || item.kno == 1"
              ></i>
            </li>
          </ul>
        </div>
        <div v-else>
          <ul v-for="(item, index) in orderList.list" :key="index">
            <li class="w40">{{ index + 1 }}</li>
            <li class="w278">
              <router-link
                :to="{ name: 'zhuwen', query: { ordno: item.ordno } }"
                >{{ item.ordno }}</router-link
              >
            </li>
            <li class="w103">{{ item.datetime }}</li>
            <li class="w110">エクセル導出</li>
            <li class="w145">{{ item.statusName }}</li>
          </ul>
        </div>
        <div class="fenye">
          <div class="fenye">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page="list.page"
              :page-size="20"
              layout="total,prev, pager, next"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 删除弹框 -->
    <el-dialog :visible.sync="dellogVisible" width="500px">
      <h3>
        <img src="../../../assets/img/tip.png" alt />
        選択中の注文書を削除してよろしいでしょうか？
      </h3>
      <div class="body">
        <p class="fl" style="line-height: 30px; margin: 0 20px">
          理由をご記入ください：
        </p>
        <el-select
          v-model="value"
          placeholder="選択"
          size="mini"
          @change="reason"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <div class="txt">
          <textarea
            name="reworkmes"
            placeholder="詳細"
            v-model="txt"
            v-show="show"
          ></textarea>
        </div>
        <div class="btn">
          <a
            href="javascript:;"
            style="color: #222; background: #f3c622"
            @click="delOrdno"
            >確定</a
          >
          <a href="javascript:;" @click="dellogVisible = false">キャンセル</a>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getOrderList, delOrder } from "../../../api/API/order";
export default {
  data() {
    return {
      flag: true,
      token: localStorage.getItem("token"),
      isChoose: 0,
      tabData: {}, // 各种状态条数
      orderList: [], //数据
      // 提交数据
      list: {
        mod: "inc",
        act: "ordersys",
        str: "getOrderList",
        token: "",
        page: 1,
        pageSize: 20,
        state: 0,
        ordno: "",
        dateStart: "",
        dateEnd: "",
      },
      dellogVisible: false, // 删除弹框
      delList: {
        mod: "inc",
        act: "ordersys",
        str: "delOrder",
        token: "",
        ordno: "",
        reason: "",
      }, // 删除数据
      options: [
        {
          value: "在庫不足",
          label: "在庫不足",
        },
        {
          value: "必要なくなった",
          label: "必要なくなった",
        },
        {
          value: "見積が遅い",
          label: "見積が遅い",
        },
        {
          value: "詳細記入を間違えた",
          label: "詳細記入を間違えた",
        },
        {
          value: "その他",
          label: "その他",
        },
        // {
        //   value: "理由をご記入ください",
        //   label: "理由をご記入ください",
        // },
      ], // 删除理由选项
      value: "",
      txt: "", // 自填删除理由
      show: false, // 是否显示历史订单列表
      total: 0, // 同条数
    };
  },
  created() {
    if (this.$route.query.state == 6) {
      this.historyOrder();
    } else {
      if (this.$route.query.state == undefined) {
        this.category(0);
      } else {
        this.category(this.$route.query.state);
      }
    }
  },
  methods: {
    // 各种状态筛选
    category(index) {
      this.isChoose = index;
      this.list.state = index;
      this.getOrderList();
    },
    // 获取数据
    getOrderList() {
      this.list.token = this.token;
      getOrderList(this.list).then((res) => {
        if (res.code != 1) return;
        this.orderList = res.data;
        this.tabData = res.data.tabData;
        this.total = res.data.total - 0;
      });
    },
    // 历史订单
    historyOrder() {
      this.list.state = 6;
      this.flag = false;
      this.getOrderList();
    },
    handleCurrentChange(val) {
      this.list.page = val;
      this.getOrderList();
    },
    // 返回订单列表
    backtrack() {
      this.flag = true;
      this.list.state = 0;
      this.isChoose = 0;
      this.getOrderList();
    },
    // 删除订单
    delOrder(item) {
      this.value = "";
      this.txt = "";
      this.delList.token = this.token;
      this.delList.ordno = item.ordno;
      this.dellogVisible = true;
    },
    // 选择删除理由
    reason() {
      if (this.value == "その他") {
        this.delList.reason = this.txt;
        this.show = true;
      } else {
        this.show = false;
        this.delList.reason = this.value;
      }
    },
    // 确认删除订单
    delOrdno() {
      if (this.value == "その他") {
        if (this.txt == "") {
          return this.$message.warning("请选择删除理由");
        } else {
          this.delList.reason = this.txt;
        }
      }
      console.log(this.delList);
      delOrder(this.delList).then((res) => {
        console.log(res);
        this.dellogVisible = false;
        if (res.code != 1) return this.$message.error("订单删除失败");
        this.$message.success("削除完了");
        this.getOrderList();
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.main {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 50px;
  padding: 30px 40px;
  .header {
    height: 44px;
    line-height: 40px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e9e9e9;
    margin-bottom: 20px;
    ul {
      float: left;
      li {
        height: 40px;
        float: left;
        margin: 0 10px;
        color: #333;
        a {
          display: inline-block;
          height: 40px;
          color: #333;
          strong {
            color: #b7040b;
          }
        }
        .choose {
          color: #b7040b;
          //   border-bottom: 2px solid #f3c622;
        }
        span {
          margin-left: 10px;
        }
      }
    }
    .history {
      margin-left: 20px;
      color: #999;
      text-decoration: underline;
      font-size: 16px;
      font-weight: 500;
      &:hover {
        color: #666;
      }
    }
    .search {
      margin: 0 10px 0 0;
      input {
        padding-left: 5px;
        width: 175px;
        height: 30px;
        border-radius: 5px;
        border: 1px solid #dcdfe6;
        margin-left: 20px;
      }
      a {
        margin-left: 20px;
        font-size: 14px;
        display: inline-block;
        width: 80px;
        height: 32px;
        background: #f3c622;
        border-radius: 2px;
        text-align: center;
        line-height: 32px;
        color: #222;
        background-color: #f3c622;
      }
    }
    .fanghui {
      margin-right: 30px;
      cursor: pointer;
    }
  }
  #search {
    height: 44px;

    .search {
      input {
        padding-left: 5px;

        width: 175px;
        height: 30px;
        border-radius: 5px;
        border: 1px solid #dcdfe6;
        &::placeholder {
          color: #cecece;
        }
      }
    }
    a {
      margin-left: 20px;
      font-size: 14px;
      display: inline-block;
      width: 80px;
      height: 32px;
      background: #f3c622;
      border-radius: 2px;
      text-align: center;
      line-height: 32px;
      color: #222;
      background-color: #f3c622;
    }
  }
  .content {
    margin-top: 0;
    padding-bottom: 50px;
    ol {
      height: 52px;
      display: flex;
      background: #f5f5f5;
      font-size: 14px;
      color: #222;

      li {
        line-height: 52px !important;
        font-weight: 600;
      }
    }
    ul {
      border-bottom: 1px solid #ccc;

      display: flex;
      &:hover {
        background: #eee;
        transition: all 0.5s;
      }
      li {
        padding: 16px 0;
      }
    }
    li {
      flex: 1;

      font-weight: 500;
      text-align: center;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        margin-left: 10px;
        cursor: pointer;
      }
      a {
        color: #b7040b;
        &:hover {
          text-decoration: underline;
        }
      }
      .el-icon-download {
        font-size: 25px;
        &:hover {
          color: #f3c622;
          cursor: pointer;
        }
      }
    }
    .w278 {
      flex: 2;
    }
    .el-icon-delete {
      width: 15px;
      height: 14px;
      color: #9ca2b2;
      cursor: pointer;
      margin-left: 13px;
    }
  }
}
h3 {
  height: 26px;
  background: #eee;
  line-height: 26px;
  img {
    margin: 0 10px 0 20px;
    vertical-align: middle;
  }
}
.body {
  margin-top: 50px;
  height: 200px;
  text-align: center;
  .txt {
    margin: 10px 0 20px 20px;
    height: 100px;
    textarea {
      padding: 10px;
      height: 80px;
      width: 160px;
      margin-left: 185px;
      border: 1px solid #dcdfe6;
    }
  }
  .btn {
    margin-right: 30px;
    a {
      padding: 0 20px;
      height: 30px;
      line-height: 30px;
      float: right;
      margin-left: 20px;
      color: #333;
      border-radius: 2px;
    }
  }
}
.fenye {
  width: 500px;
  margin: 30px auto;
  text-align: center;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #f3c622;
  color: #222;
}
</style>